define('presentation/signup/common/signupPageIndicatorWidget',[
    'i18next',
    'presentation/signup/common/signupNavigationManager',
    'settings/navigationConfiguration'
], () => {
    const _navigationConfiguration = require('settings/navigationConfiguration');

    const SignupNavigationManagerConstructor = require('presentation/signup/common/signupNavigationManager');
    const _signupNavigationManager = new SignupNavigationManagerConstructor();
    _signupNavigationManager.init();

    const ROUTE_ID__SIGNUP_FREE_TRIAL = _navigationConfiguration.routesById.signupFreeTrial.routeId;
    const ROUTE_ID__SIGNUP_SCHEDULING = _navigationConfiguration.routesById.signupScheduling.routeId;
    const ROUTE_ID__SIGNUP_SUCCESS =  _navigationConfiguration.routesById.signupSuccess.routeId;

    const HIDDEN_ROUTE_IDS = [ROUTE_ID__SIGNUP_SCHEDULING, ROUTE_ID__SIGNUP_SUCCESS];

    // Outside the flow, so there is no step to count and getStepPosition() would return NaN,
    // but the meter stays up and empty rather than disappearing.
    const ZERO_PROGRESS_ROUTE_IDS = [ROUTE_ID__SIGNUP_FREE_TRIAL];

    const HIDDEN_STATE = { isVisible: false, isStepMessageVisible: false, step: 0, totalSteps: 0, percentage: 0 };
    const ZERO_PROGRESS_STATE = { isVisible: true, isStepMessageVisible: false, step: 0, totalSteps: 0, percentage: 0 };

    const _getStepState = () => {
        const routeId = _signupNavigationManager.getRouteId();

        if (HIDDEN_ROUTE_IDS.indexOf(routeId) !== -1) {
            return HIDDEN_STATE;
        }

        if (ZERO_PROGRESS_ROUTE_IDS.indexOf(routeId) !== -1) {
            return ZERO_PROGRESS_STATE;
        }

        const { step, totalSteps } = _signupNavigationManager.getStepPosition();

        return {
            isVisible: true,
            isStepMessageVisible: true,
            step: step,
            totalSteps: totalSteps,
            percentage: totalSteps > 0 ? (step / totalSteps) * 100 : 0
        };
    };

    const _animateProgressBar = (start, end, observable) => {
        if (start === end) {
            observable(end);
            return;
        }

        const stepTime = 10;  // handles duration of animation
        const stepAmount = Math.abs(end - start) / 20; // handles smoothness of animation

        let current = start;
        const step = end > start ? stepAmount : -stepAmount;

        const interval = setInterval(() => {
            current += step;
            if ((step > 0 && current >= end) || (step < 0 && current <= end)) {
                current = end;
                clearInterval(interval);
            }
            observable(current);
        }, stepTime);
    };

    const _setIndicatorWidgetState = (isPageIndicatorVisible, progressPercentage) => {
        const { isVisible, percentage } = _getStepState();

        if (isVisible === false) {
            isPageIndicatorVisible(false);
            progressPercentage(0);
            return;
        }

        isPageIndicatorVisible(true);

        _animateProgressBar(progressPercentage(), percentage, progressPercentage);
    };

    return {
        getStepState: _getStepState,
        setIndicator: _setIndicatorWidgetState,
    };
});

